// components/stores/tabs/HeaderTabs.tsx
"use client";

import React from "react";
import { Settings } from "lucide-react";
import { ShortLGS } from "modules/common/model/models";
import { useLGSSettingsDialog } from "modules/lgs/stores/useLGSSettingsStore";
import { TabsList } from "modules/common/components/ui/tabs";
import { ICON_SIZE } from "modules/common/components/navigation/Menu";
import { cn } from "utils/utils";
import Link from "next/link";

interface HeaderTabsProps {
  userLgs: ShortLGS[];
  currentSlug?: string;
  className?: string;
}

export function LGSHeaderTabs({
  userLgs,
  currentSlug,
  className,
}: HeaderTabsProps) {
  const { setOpen, openWithCoords } = useLGSSettingsDialog();

  const currentStore =
    userLgs.find((store) => store.slug === currentSlug) || userLgs[0];

  return (
    <div
      className={cn(
        "m-0 flex w-full items-center gap-4 pb-1 md:mb-2 md:py-1",
        className
      )}
    >
      <TabsList
        variant="border"
        className="no-scrollbar min-w-0 flex-1 flex-nowrap overflow-x-auto"
      >
        {userLgs.map((store) => {
          const isActive = currentSlug === store.slug;
          return (
            <Link
              key={store.wotcId}
              href={`/x/stores/${store.slug}`}
              role="tab"
              className={cn(
                "tab-border-3 tab text-nowrap",
                isActive &&
                  "tab-active text-primary border-[rgb(168,139,255)!important]"
              )}
              aria-selected={isActive}
              aria-controls={`tab-panel-${store.slug}`}
              id={`tab-trigger-${store.slug}`}
            >
              {store.name}
            </Link>
          );
        })}
      </TabsList>
      <div
        className="tooltip tooltip-left flex-shrink-0"
        data-tip="Store settings"
      >
        <button
          className="btn btn-circle btn-sm btn-primary hidden md:flex"
          aria-label="Open store settings"
          onClick={() => {
            if (currentStore) {
              openWithCoords([currentStore.longitude, currentStore.latitude]);
            } else {
              setOpen(true);
            }
          }}
        >
          <Settings size={ICON_SIZE} />
        </button>
      </div>
    </div>
  );
}
